import * as Types from '../../tenants/kwg/generated';

import { MeFragmentDoc } from './users.fragment.g';
import { RoleAssignmentFragmentDoc } from '../roleAssigments/roleAssignments.fragment.g';
import { GroupFragmentDoc } from '../groups/groups.fragment.g';
import { useQuery, useSuspenseQuery, useInfiniteQuery, useSuspenseInfiniteQuery, UseQueryOptions, UseSuspenseQueryOptions, UseInfiniteQueryOptions, InfiniteData, UseSuspenseInfiniteQueryOptions } from '@tanstack/react-query';
import { fetcher } from '../fetcher';


export const MeDocument = `
    query Me {
  me {
    ...Me
  }
}
    ${MeFragmentDoc}
${RoleAssignmentFragmentDoc}
${GroupFragmentDoc}`;

export const useMeQuery = <
      TData = Types.MeQuery,
      TError = unknown
    >(
      variables?: Types.MeQueryVariables,
      options?: Omit<UseQueryOptions<Types.MeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<Types.MeQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<Types.MeQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['Me'] : ['Me', variables],
    queryFn: fetcher<Types.MeQuery, Types.MeQueryVariables>(MeDocument, variables),
    ...options
  }
    )};

export const useSuspenseMeQuery = <
      TData = Types.MeQuery,
      TError = unknown
    >(
      variables?: Types.MeQueryVariables,
      options?: Omit<UseSuspenseQueryOptions<Types.MeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseQueryOptions<Types.MeQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseQuery<Types.MeQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['Me'] : ['Me', variables],
    queryFn: fetcher<Types.MeQuery, Types.MeQueryVariables>(MeDocument, variables),
    ...options
  }
    )};

export const useInfiniteMeQuery = <
      TData = InfiniteData<Types.MeQuery>,
      TError = unknown
    >(
      variables: Types.MeQueryVariables,
      options: Omit<UseInfiniteQueryOptions<Types.MeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<Types.MeQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<Types.MeQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['Me.infinite'] : ['Me.infinite', variables],
      queryFn: (metaData) => fetcher<Types.MeQuery, Types.MeQueryVariables>(MeDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

export const useSuspenseInfiniteMeQuery = <
      TData = InfiniteData<Types.MeQuery>,
      TError = unknown
    >(
      variables: Types.MeQueryVariables,
      options: Omit<UseSuspenseInfiniteQueryOptions<Types.MeQuery, TError, TData>, 'queryKey'> & { queryKey?: UseSuspenseInfiniteQueryOptions<Types.MeQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useSuspenseInfiniteQuery<Types.MeQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['Me.infinite'] : ['Me.infinite', variables],
      queryFn: (metaData) => fetcher<Types.MeQuery, Types.MeQueryVariables>(MeDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};
